import {
  collection,
  doc,
  getDocs,
  limit,
  orderBy,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import { firebaseAuth, firebaseDb } from '../firebase';

export const notificationService = {
  /**
   * Obtenir les notifications de l'utilisateur
   */
  getNotifications: async (limit = 50, unreadOnly = false) => {
    try {
      if (!firebaseAuth?.currentUser) {
        return { success: false, error: 'Non authentifié', notifications: [], count: 0 };
      }
      if (!firebaseDb) {
        return { success: false, error: 'Firestore non configuré', notifications: [], count: 0 };
      }
      const uid = firebaseAuth.currentUser.uid;
      let q = query(
        collection(firebaseDb, 'users', uid, 'notifications'),
        orderBy('createdAt', 'desc'),
        limit(limit)
      );
      if (unreadOnly) {
        q = query(
          collection(firebaseDb, 'users', uid, 'notifications'),
          where('read', '==', false),
          orderBy('createdAt', 'desc'),
          limit(limit)
        );
      }
      const snap = await getDocs(q);
      const notifications = snap.docs.map((d) => ({ id: d.id, _id: d.id, ...d.data() }));
      return {
        success: true,
        notifications,
        count: notifications.length,
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des notifications:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de la récupération des notifications',
        notifications: [],
      };
    }
  },

  /**
   * Obtenir le nombre de notifications non lues
   */
  getUnreadCount: async () => {
    try {
      if (!firebaseAuth?.currentUser) {
        return { success: true, count: 0 };
      }
      if (!firebaseDb) {
        return { success: false, error: 'Firestore non configuré', count: 0 };
      }
      const uid = firebaseAuth.currentUser.uid;
      const q = query(
        collection(firebaseDb, 'users', uid, 'notifications'),
        where('read', '==', false),
        limit(200)
      );
      const snap = await getDocs(q);
      return {
        success: true,
        count: snap.size,
      };
    } catch (error) {
      console.error('Erreur lors du comptage des notifications:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors du comptage',
        count: 0,
      };
    }
  },

  /**
   * Marquer une notification comme lue
   */
  markAsRead: async (notificationId) => {
    try {
      if (!firebaseAuth?.currentUser) {
        return { success: false, error: 'Non authentifié' };
      }
      if (!firebaseDb) {
        return { success: false, error: 'Firestore non configuré' };
      }
      const uid = firebaseAuth.currentUser.uid;
      const ref = doc(firebaseDb, 'users', uid, 'notifications', notificationId);
      await updateDoc(ref, { read: true });
      return {
        success: true,
        notification: { id: notificationId, _id: notificationId, read: true },
      };
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la notification:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de la mise à jour',
      };
    }
  },

  /**
   * Marquer toutes les notifications comme lues
   */
  markAllAsRead: async () => {
    try {
      if (!firebaseAuth?.currentUser) {
        return { success: false, error: 'Non authentifié' };
      }
      if (!firebaseDb) {
        return { success: false, error: 'Firestore non configuré' };
      }
      const uid = firebaseAuth.currentUser.uid;
      const q = query(
        collection(firebaseDb, 'users', uid, 'notifications'),
        where('read', '==', false),
        limit(200)
      );
      const snap = await getDocs(q);
      await Promise.all(
        snap.docs.map((d) => updateDoc(doc(firebaseDb, 'users', uid, 'notifications', d.id), { read: true }))
      );
      return {
        success: true,
        updatedCount: snap.size,
      };
    } catch (error) {
      console.error('Erreur lors de la mise à jour des notifications:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de la mise à jour',
      };
    }
  },
};





